import * as types from './mutation-types';

export default {
  [types.SET_PIGMENT](state, pigment) {
    state.pigment = pigment;
  },
  [types.SET_INDUSTRY](state, industry) {
    state.activeIndustry = industry;
  },
  [types.SET_DOCUMENT_FAVORITE](state, favorite) {
    state.documentFavorite = favorite;
  },
  [types.SAVE_DOCUMENT_FAVORITE](state, favorite) {
    state.documentFavorite = favorite;
  },
  [types.DELETE_DOCUMENT_FAVORITE](state) {
    state.documentFavorite = null;
  }
};
